import React, { useState } from 'react';
import { Button } from './ui/button';
import { isIOS, postMessage } from '../helpers/utils';
import { unlockPersistentAudio } from '../helpers/persistentAudio';
import { useSimulationContext } from '../providers/SimulationProvider';
import { MESSAGE_TYPES, ANAM_VIDEO_ELEMENT_ID, RENDERER } from '../constants/simulationConstants';

function IosAudioUnlockOverlay() {
  const [isAudioUnlocked, setIsAudioUnlocked] = useState(false);
  const { isClientInitialized, renderer } = useSimulationContext();

  const shouldShowOverlay = isIOS() && isClientInitialized && !isAudioUnlocked;

  if (!shouldShowOverlay) return null;

  const unlockAnamVideo = () => {
    const video = document.getElementById(ANAM_VIDEO_ELEMENT_ID);
    if (!video) return;

    video.muted = false;

    const playPromise = video.play();
    if (playPromise && typeof playPromise.catch === 'function') {
      playPromise.catch((error) => {
        console.error('[iOS Audio Unlock] video.play() failed:', error);
      });
    }
  };

  const handleUnlock = (renderer) => {
    if (renderer === RENDERER.ANAM) unlockAnamVideo();
    unlockPersistentAudio();
    setIsAudioUnlocked(true);
    postMessage({ type: MESSAGE_TYPES.INITIALIZED });
  };

  return (
    <div
      className='absolute inset-0 z-50 flex items-center justify-center bg-black/40 touch-manipulation'
      onClick={() => handleUnlock(renderer)}
      role='presentation'
    >
      <Button type='button' aria-label='Tap to enable sound'>
        Start Conversation
      </Button>
    </div>
  );
}

export default IosAudioUnlockOverlay;
